export class SurveyAnalysisTabelMapping {
  id: number = 0;
  pointList: SurveyAnalysisCountAndPercent[] = [];
  // N段階
  stageCount: number = 1;
  size: number = 1;
  total: number = 0;
  totalOnlyAnswered: number = 0;

  deserialize(input: any): SurveyAnalysisTabelMapping {
    this.id = input.id;
    this.stageCount = input.stageCount;
    this.size = input.size;
    if (this.stageCount > 0) {
      // 未回答含め stageCount + 1 個の配列を用意する
      for (let i = 0; i < this.stageCount + 1; i++) {
        this.pointList.push(new SurveyAnalysisCountAndPercent());
      }
    }
    return this;
  }

  setTotal() {
    let total: number = 0;
    this.pointList.map((p: SurveyAnalysisCountAndPercent) => (total += p.items));
    this.total = total;
  }

  setTotalOnlyAnswered() {
    let total: number = 0;
    this.pointList.map((p: SurveyAnalysisCountAndPercent) => (total += p.items));
    total -= this.pointList[this.pointList.length - 1].items;
    this.totalOnlyAnswered = total;
  }
  countUpdateByRatio(score: number) {
    const range = Math.floor((100 / this.stageCount) * 10) / 10;
    if (0 <= score && score < 100) {
      this.pointList[Math.floor(score / range)].items++;
    } else if (score === 100) {
      this.pointList[this.pointList.length - 2].items++;
    } else {
      // 未回答等は最後の要素に設定する。
      this.pointList[this.pointList.length - 1].items++;
    }
  }

  unanswerdUpdate() {
    const count = this.pointList.reduce(function (sum, p: SurveyAnalysisCountAndPercent) {
      return sum + p.items;
    }, 0);
    const lastItems = this.size - count > 0 ? this.size - count : 0;
    this.pointList[this.pointList.length - 1].items = lastItems;
  }

  trancePercent() {
    this.setTotal();
    this.pointList.map((p: SurveyAnalysisCountAndPercent, i) => (this.pointList[i].percent = Math.floor(((p.items * 100) / this.total) * 10) / 10));
  }

  getRateAverage(): number {
    this.setTotalOnlyAnswered();
    // 未回答は除く
    const currentPointList = this.pointList.slice(0, -1);

    let totalRate = 0;
    currentPointList.map((p: SurveyAnalysisCountAndPercent, i) => (totalRate += p.items * (i + 1)));
    return Math.floor((totalRate / this.totalOnlyAnswered) * 10) / 10;
  }

  getPositivePer(): number {
    // 上位二段階までの評価を持つ生徒の割合を返す。
    this.setTotalOnlyAnswered();

    const length = this.pointList.length;
    if (length > 3) {
      let count: number = this.pointList[length - 3].items + this.pointList[length - 2].items;
      return Math.floor((count / this.totalOnlyAnswered) * 100 * 10) / 10;
    }

    return 0;
  }
}

export class SurveyAnalysisCountAndPercent {
  items: number = 0;
  percent: number = 0;
}
